import { Stack, Typography } from '@mui/joy';
import { CalendarBlank, LockSimple, LockSimpleOpen } from '@phosphor-icons/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledValue } from 'core/elements';
import { getDateRangeValue } from 'core/utils';
import { IPricingProfile, PricingProfileAccessType } from 'pricing/types';
import { Direction, Level } from 'theme/enums';

interface IProps {
  pricingProfile: IPricingProfile | null;
}

export const PageSubtitle = ({ pricingProfile }: IProps) => {
  const { t } = useTranslation();

  const dateRange = useMemo(
    () => getDateRangeValue(pricingProfile?.startDate, pricingProfile?.endDate),
    [pricingProfile?.startDate, pricingProfile?.endDate]
  );

  const accessType = useMemo(() => {
    return pricingProfile?.accessType === PricingProfileAccessType.COMPANY
      ? t('labelPublic')
      : t('labelPrivate');
  }, [pricingProfile?.accessType, t]);

  return (
    <Stack direction={Direction.ROW} spacing={2}>
      {pricingProfile?.agreementId && (
        <LabeledValue
          label={t('labelAgreementId')}
          value={pricingProfile.agreementId}
          options={{ inline: true }}
        />
      )}
      <Typography level={Level.TITLE_SM}>
        <CalendarBlank /> {dateRange}
      </Typography>
      <Typography level={Level.TITLE_SM} sx={{ display: 'flex', gap: 1 }}>
        {pricingProfile?.accessType === PricingProfileAccessType.COMPANY ? (
          <LockSimpleOpen />
        ) : (
          <LockSimple weight="fill" />
        )}
        {accessType}
      </Typography>
    </Stack>
  );
};
